import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';
@Component({
  selector: 'custom-tag',
  standalone: true,
  imports: [CommonModule, TooltipModule],
  templateUrl: './custom-tag.component.html',
  styleUrl: './custom-tag.component.scss'
})
export class CustomTagComponent {
  @Input() toolTip !: string;
  @Input() iconClass !: string;
  @Input() backgroundColor !: string;

}
